import React from 'react';
import {
  formatReviewDate,
  normaliseReviewText,
  toRating,
} from './reviewHelpers.js';

export const StarIcon = () => (
  <img src="/assets/svg/star.svg" alt="" className="w-4 h-4" />
);

export const Stars = ({ rating }) => {
  const stars = toRating(rating);

  return (
    <p className="flex ml-auto text-yellow-400 mb-3" aria-label={`${stars} / 5`}>
      {Array.from({ length: stars }, (_, index) => (
        <StarIcon key={index} />
      ))}
    </p>
  );
};

export const ReviewCard = ({ review, locale }) => {
  const date = formatReviewDate(review.time, locale);

  return (
    <div className="bg-gray-50 p-6 rounded-lg">
      <div className="mb-2">
        <h5 className="font-semibold leading-tight">{review.author_name}</h5>
        {date && (
          <time dateTime={date.dateTime} className="block text-gray-500 text-xs">
            {date.label}
          </time>
        )}
      </div>
      <Stars rating={review.rating} />
      <p className="text-gray-600 text-sm whitespace-pre-line">
        {normaliseReviewText(review.text)}
      </p>
    </div>
  );
};

export const LoadingSkeleton = () => (
  <div className="bg-gray-50 p-6 rounded-lg animate-pulse">
    <div className="flex items-center justify-between mb-3">
      <div className="h-4 bg-gray-300 rounded w-32"></div>
      <div className="h-3 bg-gray-300 rounded w-20"></div>
    </div>
    <div className="flex mb-3">
      {Array.from({ length: 5 }, (_, index) => (
        <div key={index} className="w-4 h-4 bg-gray-300 rounded mr-1"></div>
      ))}
    </div>
    <div className="space-y-2">
      <div className="h-3 bg-gray-300 rounded w-full"></div>
      <div className="h-3 bg-gray-300 rounded w-3/4"></div>
    </div>
  </div>
);

export default ReviewCard;
